<div class="twc-ml-3 twc-mt-2 twc-mb-3">
    <div class="twc-body twc-mb-0" *ngIf="label">{{label | translate}}</div>
    <div class="twc-row margin-row">
        <div class="twc-col-4">
            <span class="twc-tiny">{{getValueName(property, 0)}}</span>
            <div class="margin-input">
                <input class="twc-input" type="{{inputType}}" [(ngModel)]="value[0]" (ngModelChange)="onChange(0)"
                    [readonly]="!property.editable()">
            </div>
        </div>

        <div class="twc-col-4">
            <span class="twc-tiny">{{getValueName(property,1)}}</span>
            <div class="margin-input">
                <input class="twc-input" type="{{inputType}}" [(ngModel)]="value[1]" (ngModelChange)="onChange(1)"
                    [readonly]="!property.editable()">
            </div>
        </div>

        <div class="twc-col-4">
            <span class="twc-tiny">{{getValueName(property, 2)}}</span>
            <div class="margin-input">
                <input class="twc-input" type="{{inputType}}" [(ngModel)]="value[2]" (ngModelChange)="onChange(2)"
                    [readonly]="!property.editable()">
            </div>
        </div>
    </div>
</div>